import { IPaginationMeta } from "../types/ownerDashboard.types";

const MAX_ITEMS_PER_PAGE = 50;

interface PaginatedResponse<T> {
  items: T[];
  pagination: IPaginationMeta;
}

export async function fetchAllPaginatedItems<T>(
  fetchPage: (page: number, perPage: number) => Promise<PaginatedResponse<T>>
): Promise<T[]> {
  const firstPage = await fetchPage(1, MAX_ITEMS_PER_PAGE);

  if (firstPage.pagination.last_page <= 1) {
    return firstPage.items;
  }

  const remainingPages = await Promise.all(
    Array.from({ length: firstPage.pagination.last_page - 1 }, (_, index) =>
      fetchPage(index + 2, MAX_ITEMS_PER_PAGE)
    )
  );

  return [firstPage.items, ...remainingPages.map((page) => page.items)].flat();
}
